import { format, isValid } from 'date-fns';
import { pluralise } from '../index';

export const formatDateRange = (startDate: Date, endDate: Date, twoDigitYearFormat = false) => {
  if (startDate.getMonth() === endDate.getMonth()) {
    if (twoDigitYearFormat)
      return `${format(startDate, 'EEE d')} - ${format(endDate, 'EEE d MMM yy')}`;
    return `${format(startDate, 'EEE d')} - ${format(endDate, 'EEE d MMM yyyy')}`;
  }

  if (startDate.getFullYear() === endDate.getFullYear()) {
    return `${format(startDate, 'EEE d MMM')} - ${format(endDate, 'EEE d MMM yyyy')}`;
  }

  return `${format(startDate, 'EEE d MMM yyyy')} - ${format(endDate, 'EEE d MMM yyyy')}`;
};

export const formatHolidayDateSelection = (
  dates: {
    arrivalDate: Date;
    checkoutDate: Date;
    numOfNights: number;
  },
  showNights = true,
  nightsFirst = false,
  twoDigitYearFormat = false,
): string | null => {
  const { arrivalDate, checkoutDate, numOfNights } = dates;

  if (isValid(arrivalDate) && isValid(checkoutDate)) {
    const dateRange = formatDateRange(arrivalDate, checkoutDate, twoDigitYearFormat);

    if (showNights && numOfNights && nightsFirst) {
      return `${numOfNights} ${pluralise(numOfNights, 'night', 'nights')} | ${dateRange}`;
    }

    if (showNights && numOfNights) {
      return `${dateRange} (${numOfNights} ${pluralise(numOfNights, 'night', 'nights')})`;
    }

    return dateRange;
  }

  return null;
};

export const capitalizeFirstLetterOfEveryWord = (str: string): string => {
  const words = str.split(/\s+/);

  const capitalizedWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return capitalizedWords.join(' ');
};
